<ng-container *ngIf="result === ''; else resultContent">
  <div #peachPaymentContainer id="payment-form" class="embed"></div>
</ng-container>
<ng-template #resultContent>
  <div *ngIf="result === 'completed'; else unsuccessfulContent">
    <div class="center">
      <mat-card class="center">
        <img mat-card-image src="/assets/images/success.svg" alt="success icon" class="center width-150" />
        <mat-card-header>
          <mat-card-title>{{ (!addCard ? 'payment_success' : 'card_added_successfully') | translate }}</mat-card-title>
        </mat-card-header>
        @if (!addCard) {
          <mat-card-content
            [innerHTML]="
              'payment_summary'
                | translate
                  : {
                      treating_doctor: payment?.treatingDoctor,
                      payment_amount: payment?.paymentAmount | currency: currency : 'symbol-narrow',
                      time_stamp: (timestamp | customDate: 'T DDDD ZZ'),
                    }
            "
          ></mat-card-content>
        } @else {
          <mat-card-content [innerHTML]="'add_card_summary' | translate"></mat-card-content>
        }
        <button mat-flat-button *ngIf="result === 'completed'" (click)="onDownload()" color="accent" type="button" class="download-button">
          {{ 'download_summary_of_payments' | translate }}
        </button>
      </mat-card>
    </div>
  </div>
</ng-template>
<ng-template #unsuccessfulContent>
  <div *ngIf="result === 'cancelled' || result === 'expired'">
    <mat-card class="center">
      <mat-card-header>
        <mat-card-title *ngIf="result === 'cancelled'">{{ 'payment_cancelled' | translate }}</mat-card-title>
        <mat-card-title *ngIf="result === 'expired'">{{ 'payment_request_expired' | translate }}</mat-card-title>
      </mat-card-header>
      <button mat-stroked-button (click)="loadPeachPayScript()">
        <mat-icon svgIcon="refresh"></mat-icon>
        {{ 'please_try_again' | translate }}
      </button>
    </mat-card>
  </div>
  <div *ngIf="result === 'error'">
    <mat-card class="center">
      <mat-card-header>
        <mat-card-title>{{ 'payment_request_error' | translate }}</mat-card-title>
      </mat-card-header>
      <button mat-stroked-button (click)="loadPeachPayScript()">
        <mat-icon svgIcon="refresh"></mat-icon>
        {{ 'please_try_again' | translate }}
      </button>
    </mat-card>
  </div>
</ng-template>
